import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router';
import { MapIcon } from '@heroicons/react/24/outline';
import PathwaysIcon from '@/assets/react-icons/md/PathwaysIcon.svg';
import ListHeader from '../core/ListHeader';
import ListItemLink from '../core/ListItemLink';

const PathwayAnalysesList = ({ pathways }) => {
  const { projectId } = useParams();
  const navigate = useNavigate();

  const gotoPathway = (event, pathway) => {
    event.preventDefault();
    navigate(`/projects/${projectId}/build/pathways/${pathway.id}/${pathway.case_id}`);
  };

  return (
    <div className="divide-y divide-gray-75">
      <ListHeader title="Pathways" icon={PathwaysIcon} />
      <ul className="p-2">
        {pathways?.length ? (
          pathways.map(pathway => (
            <li key={pathway.id} className="group/item relative">
              <ListItemLink to={`/projects/${projectId}/analysis/pathways/${pathway.id}`} end>
                <span className="truncate">{pathway.name}</span>
                <div className="group-hover/item:flex absolute right-5 hidden bg-canvas">
                  <MapIcon onClick={event => gotoPathway(event, pathway)} className="h-5 w-5" />
                </div>
              </ListItemLink>
            </li>
          ))
        ) : (
          <li className="text-center text-sm">No pathways found</li>
        )}
      </ul>
    </div>
  );
};

PathwayAnalysesList.propTypes = {
  pathways: PropTypes.arrayOf(PropTypes.object),
};

export default PathwayAnalysesList;
